<template>
  <div>
    <LoginForm v-if="!isAuthenticated" @login-success="onLoginSuccess" />

    <div v-else class="home-page d-flex flex-column">
      <!-- Top bar -->
      <div class="header d-flex justify-content-end align-items-center">
        <b-button variant="primary" class="mr-2" @click="$router.push({ name: 'LogsDashboard' })">
          Logs Dashboard
        </b-button>
        <b-button variant="danger" @click="onLogout">Logout</b-button>
      </div>

      <!-- Centered title + martini icon -->
      <div class="content d-flex justify-content-center align-items-center flex-grow-1">
        <div class="title-container">
            <img :src="martiniIcon" alt="Martini Glass" class="martini-icon" />
            <h1 class="fancy-title">Mobile Device Management</h1>
        </div>
      </div>

      <ChatPopup />
    </div>
  </div>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue'
import ChatPopup  from '@/components/ChatPopup.vue'

export default {
  name: 'Home',
  components: { LoginForm, ChatPopup },
  data() {
    return {
      isAuthenticated: localStorage.getItem('emm_logged_in') === 'true'
    }
  },
  computed: {
    martiniIcon() {
      // Place your icon at src/assets/martini.png (or .svg)
      return require('@/assets/martini.png')
    }
  },
  methods: {
    onLoginSuccess() {
      localStorage.setItem('emm_logged_in', 'true')
      this.isAuthenticated = true
    },
    onLogout() {
      localStorage.removeItem('emm_logged_in')
      this.isAuthenticated = false
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lobster&display=swap');

.home-page {
  min-height: 100vh;
}

.header {
  padding: 1rem;
  background: #f5f5f5;
}

/* Content area */
.content {
  text-align: center;
}

/* Container for icon + title */
.title-container {
  display: inline-flex;
  align-items: center;
}

/* Martini icon styling */
.martini-icon {
  width: 64px;
  height: 64px;
  margin-right: 12px;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.2));
}

/* Fancy title */
.fancy-title {
  font-family: 'Lobster', cursive;
  font-size: 3.5rem;
  /*color: #FDC300;*/
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  margin: 0;
}
</style>